// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Uuid from "uuid";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";

function fromString(string) {
  if (Uuid.validate(string)) {
    return Primitive_option.some(string);
  }
}

export {
  fromString,
}
/* uuid Not a pure module */
